<div class="vig-layout">
  <header class="vig-layout--header">
    <vig-header />
  </header>
  <div class="vig-layout--main">
    @if (_userLoggedIn) {
      <nav aria-label="Navigation bar" class="vig-layout--sidebar">
        <vig-navbar />
      </nav>
    }
    <main class="vig-layout--content">
      <ng-content></ng-content>
    </main>
  </div>
  @if (!_userLoggedIn) {
    <footer class="vig-layout--footer">
      <vig-footer />
    </footer>
  }
</div>
